<div>
    <lib-edl-cf-label [title]="model.config.title"></lib-edl-cf-label>

    <!-- Text Display -->
    <p *ngIf="!shouldShowBuildings">{{displayText}}</p>

    <!-- Building Picker - Print -->
    <p *ngIf="isPrintMode && shouldShowBuildings" edlFormVar="answer" #edlFormVar="edlFormVar">{{edlFormVar.control?.value}}</p>

    <!-- Building Picker - Edit -->
    <select *ngIf="!isPrintMode && shouldShowBuildings" class="form-select" formControlName="answer">
        <option *ngFor="let building of buildings" [value]="building.name">
            {{ building.name }}
        </option>
        <option *ngIf="nonExistingBuilding" [value]="nonExistingBuilding">
            (No Longer Assigned) {{ nonExistingBuilding }} 
        </option>
    </select>
</div>

